import React from 'react';

import ChevronDown from '@/assets/icons/ChevronDown';

import { CollapsibleContent } from './Collapsible';

import styles from './Collapsible.module.css';

type CollapsibleContainerProps = {
  title: React.ReactNode;
  open: boolean;
  badge?: React.ReactNode;
  onOpenChange: (open: boolean) => void;
  children: React.ReactNode;
  headerChildren?: React.ReactNode;
  maxHeight?: string;
  showTopBorder?: boolean;
  headerPadding?: string;
  titleLeftMargin?: number;
};

export default function CollapsibleContainer({
  title,
  open,
  onOpenChange,
  badge,
  headerChildren,
  children,
  showTopBorder = true,
  headerPadding = '8px 8px 8px 0px',
  titleLeftMargin = 8,
}: CollapsibleContainerProps) {
  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          cursor: 'pointer',
          userSelect: 'none',
          background: 'var(--tractie-color-background-default)',
          gap: 8,
          padding: headerPadding,
          borderTop: showTopBorder ? '1px solid var(--tractie-color-border-subtle)' : undefined,
          top: 0,
          zIndex: 999,
        }}
      >
        <div
          onClick={() => onOpenChange(!open)}
          style={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'space-between' }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <h3 style={{ margin: `0 0 0 ${titleLeftMargin}px`, fontSize: '16px', fontWeight: 400 }}>{title}</h3>
            {badge && <span className={styles.badge}>{badge}</span>}
          </div>

          <ChevronDown
            width={24}
            height={24}
            data-testid='chevron-down-icon'
            style={{
              fill: 'var(--tractie-color-content-interactive-default)',
              transition: 'transform 0.2s',
              transform: open ? 'rotate(-180deg)' : 'rotate(0deg)',
            }}
          />
        </div>
        {headerChildren}
      </div>
      <CollapsibleContent className={styles.CollapsibleContent} open={open} onOpenChange={onOpenChange}>
        {children}
      </CollapsibleContent>
    </>
  );
}
